import React from 'react';
import { useTranslation } from 'react-i18next';

import { TransitionConditionHandler } from './ConditionsHandler';

import { SelectLabel } from '@weezevent/nacre';

import { TranslatableInput } from '../../components';
import useAppContext from '../../../../../../context/useAppContext';

export const TransitionConditionSettings = ({ condition, handleCondition, handleConditionObject, languageOptions, defaultLanguage }) => {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const conditionOptions = TransitionConditionHandler.get_allowed_conditions(organization.pk)
        .filter(Boolean)
        .map(cond => ({
            text: t(`ticket.moderation.statusesTransitions.transitionConditionsList.conditionTypes.${cond}`),
            value: cond
        }));

    const handleChange = React.useCallback(
        (field, value, selectedLanguage) => {
            let trans = condition.translations;
            trans[field][selectedLanguage] = value;
            if (selectedLanguage !== defaultLanguage) {
                if (!value) {
                    trans[field][selectedLanguage] = '';
                }
                handleCondition('translations', trans);
            } else {
                handleConditionObject({ ...condition, [field]: value, translations: trans });
            }
        },
        [handleConditionObject, handleCondition, condition, defaultLanguage]
    );

    return (
        <>
            <TranslatableInput
                field="name"
                label={t('ticket.moderation.statusesTransitions.conditions.detail.nameLabel')}
                placeholder={t('ticket.moderation.statusesTransitions.conditions.detail.namePlaceholder')}
                item={condition}
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                handleChange={handleChange}
            />
            <TranslatableInput
                field="description"
                label_prefix="ticket.common"
                placeholder_prefix="ticket.common"
                item={condition}
                inputType="text"
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                handleChange={handleChange}
            />

            <SelectLabel
                label={t('ticket.moderation.statusesTransitions.conditions.detail.typeLabel')}
                useNew
                value={condition.type}
                options={conditionOptions}
                placeholder={t('ticket.common.action.select')}
                onChange={value => handleCondition('type', value)}
                disabled={Boolean(condition.id)}
            />
        </>
    );
};
